import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { CommonService } from 'src/app/core/services/common.service';
import { FooterData, HeaderFooterService } from 'src/app/core/services/header-footer.service';
import { QueryStringService } from 'src/app/core/services/query-string.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CoreModule]
})
export class FooterComponent implements OnInit {
  footerData: FooterData = {} as FooterData;
  activeItem: string;
  isDesktopUp = false;
  applyNowUrl = '';

  constructor(private footerService: HeaderFooterService, @Inject(DOCUMENT) private dom: Document, private commonService: CommonService, private queryStringService: QueryStringService) {
    this.activeItem = '';
  }

  ngOnInit(): void {
    this.footerService.footerConfiguration.subscribe((data: FooterData | false) => {
      if (data) {
        this.footerData = data;
        if (this.commonService.isPlatformBrowser()) {
          this.applyNowUrl = this.setApplyNowLink();
        }
      }
    })
    if(this.commonService.isPlatformBrowser()) {
      this.commonService.desktopUp$.subscribe(isDesktopUp => {
        this.isDesktopUp = isDesktopUp;
        this.commonService.updateLinkTabIndex(isDesktopUp ? 0 : -1, '.footer-links-container .footer-link', 2000);
      });
    }
  }

  setApplyNowLink(): string {
    return this.queryStringService.setApplyNowLink(this.footerData?.buttonLink2?.internalLink?.url);
  }
  

  /**
   * Handles the opening and closing of an accordion section in the footer.
   * 
   * This method updates the footer link attributes for accessibility, toggles the active accordion item,
   * and sets the `tabindex` of all footer links within the specified container to `0` to ensure they are focusable.
   *
   * @param column - The column object representing the accordion section. Expected to have a `cTitle` property.
   * @param container - The DOM element containing the footer links to update.
   */
  openAccordion(column: any, container: any) {
    if(this.isDesktopUp) return;
    this.commonService.updateLinkTabIndex(-1, '.footer-links-container .footer-link');
    this.activeItem = this.activeItem === column.cTitle ?  null : column.cTitle

    if (!this.activeItem) return;

    setTimeout(() => {
      container.querySelectorAll('.footer-link').forEach((link: HTMLElement) => {
        link.setAttribute('tabindex', '0');
      });
    }, 20);
    
  }
}
